import { Link } from 'react-router-dom'

import './_terms.scss';

const CCPAPolicy = () => {

  return (
    <>
    <div className="pf-content pf-content--not-home">
        <div className="pf-content__inner">
        <div className="pf-container">
            <h2 className="pf-page__title">
             CCPA Privacy Policy
            </h2>
            <div className="pf-page__descr">
                <p>This Privacy Policy for California Residents supplements the information contained in Innodev Solutions Inc.’s <Link to="/privacypolicy" className='terms-link'>Privacy Policy</Link> and 
                    applies solely to all visitors, users, and others who reside in the State of California (“consumers” or “you”). We adopt 
                    this notice to comply with the California Consumer Privacy Act of 2018 (CCPA), and any terms defined in the CCPA have the same 
                    meaning when used in this Policy.</p>

            </div>
          <div className="pf-main-list">

            <h5>Information We Collect</h5>
            <p>
                Our Website collects information that identifies, relates to, describes, references, is reasonably capable of being associated with, 
                or could reasonably be linked, directly or indirectly, with a particular consumer, household, or device (“personal information”). 
                Personal information does not include:
            </p>
            <ul>
                <li>
                  Publicly available information from government records. 
                </li>
                <li>
                  Deidentified or aggregated consumer information.
                </li>
                <li>
                  Information excluded from the CCPA’s scope, like:
                  <ul>
                    <li>
                        health or medical information covered by the Health Insurance Portability and Accountability Act of 1996 (HIPAA) and the 
                        California Confidentiality of Medical Information Act (CMIA), clinical trial data, or other qualifying research data; and
                    </li>
                    <li>
                        personal information covered by certain sector-specific privacy laws, including the Fair Credit Reporting Act (FCRA), 
                        the Gramm-Leach-Bliley Act (GLBA) or California Financial Information Privacy Act (FIPA), and the Driver’s Privacy 
                        Protection Act of 1994.
                    </li>
                  </ul>
                </li>
            </ul>
            <p>In particular, our Website has collected the following categories of personal information from consumers within the last 12 months:</p>

            <table>
                <thead>
                <tr>
                    <th>Category</th>
                    <th>Examples</th>
                    <th>Collected</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>A. Identifiers.</td>
                    <td>A real name, alias, postal address, unique personal identifier, online identifier, Internet Protocol address, email address, 
                        account name, Social Security number, driver’s license number, passport number, or other similar identifiers.</td>
                    <td>YES</td>
                </tr>
                <tr>
                    <td>B. Personal information categories listed in the California Customer Records statute (Cal. Civ. Code § 1798.80(e)).</td>
                    <td>A name, signature, Social Security number, physical characteristics or description, address, telephone number, passport number, driver’s license or state identification card number, insurance policy number, education, employment, employment history, bank account number, credit card number, debit card number, or any other financial information, medical information, or health insurance information.
                    Some personal information included in this category may overlap with other categories.
                    </td>
                    <td>YES</td>
                </tr>
                <tr>
                    <td>C. Protected classification characteristics under California or federal law.</td>
                    <td>Age (40 years or older), race, color, ancestry, national origin, citizenship, religion or creed, marital status, medical 
                        condition, physical or mental disability, sex (including gender, gender identity, gender expression, pregnancy or 
                        childbirth and related medical conditions), sexual orientation, veteran or military status, genetic information (including 
                        familial genetic information).</td>
                    <td>YES</td>
                </tr>
                <tr>
                    <td>D. Commercial information.</td>
                    <td>Records of personal property, products or services purchased, obtained, or considered, or other purchasing 
                        or consuming histories or tendencies.</td>
                    <td>YES</td>
                </tr>
                <tr>
                    <td>E. Biometric information.</td>
                    <td>Genetic, physiological, behavioral, and biological characteristics, or activity patterns used to extract a template or 
                        other identifier or identifying information, such as, fingerprints, faceprints, and voiceprints, iris or retina scans, 
                        keystroke, gait, or other physical patterns, and sleep, health, or exercise data.</td>
                    <td>YES</td>
                </tr>
                <tr>
                    <td>F. Internet or other similar network activity.</td>
                    <td>Browsing history, search history, information on a consumer’s interaction with a website, application, or advertisement.</td>
                    <td>YES</td>
                </tr>
                <tr>
                    <td>G. Geolocation data.</td>
                    <td>Physical location or movements.</td>
                    <td>NO</td>
                </tr>
                <tr>
                    <td>H. Sensory data.</td>
                    <td>Audio, electronic, visual, thermal, olfactory, or similar information.</td>
                    <td>YES</td>
                </tr>
                <tr>
                    <td>I. Professional or employment-related information.</td>
                    <td>Current or past job history or performance evaluations.</td>
                    <td>NO</td>
                </tr>
                <tr>
                    <td>J. Non-public education information (per the Family Educational Rights and 
                        Privacy Act (20 U.S.C. Section 1232g, 34 C.F.R. Part 99)).</td>
                    <td>Education records directly related to a student maintained by an educational institution or party acting on its behalf, 
                        such as grades, transcripts, class lists, student schedules, student identification codes, student financial information, 
                        or student disciplinary records.</td>
                    <td>NO</td>
                </tr>
                <tr>
                    <td>K. Inferences drawn from other personal information.</td>
                    <td>Profile reflecting a person’s preferences, characteristics, psychological trends, predispositions, 
                        behavior, attitudes, intelligence, abilities, and aptitudes.</td>
                    <td>YES</td>
                </tr>
                </tbody>
            </table>
            <p>Our Website obtains the categories of personal information listed above from the following categories of sources:</p>
            <ul>
                <li>Directly from you. For example, from forms you complete or products and services you purchase.</li>
                <li>Indirectly from you. For example, from observing your actions on our Website.</li>
                <li>From third parties. For example, from our business partners.</li>
            </ul>
            <h5>Use of Personal Information</h5>
            <p>
                We may use or disclose the personal information we collect for one or more of the following purposes: 
            </p>
            <ul>
                <li>To fulfill or meet the reason you provided the information. For example, if you share your name and 
                    contact information to ask a question about our products or services, we will use that personal information 
                    to respond to your inquiry. If you provide your personal information to purchase a product or service, we 
                    will use that information to process your payment. We may also save your information to facilitate new orders.</li>
                <li>To provide, support, personalize, and develop our Website, products, and services.</li>
                <li>To create, maintain, customize, and secure your account with us.</li>
                <li>To process your requests, purchases, transactions, and payments and prevent transactional fraud.</li>
                <li>To provide you with support and to respond to your inquiries, including to investigate and address your 
                    concerns and monitor and improve our responses.</li>
                <li>To personalize your Website experience and to deliver content and product and service offerings 
                    relevant to your interests, including targeted offers and ads through our Website, third-party sites, and 
                    via email or text message (with your consent, where required by law).</li>
                <li>To help maintain the safety, security, and integrity of our Website, products and services, 
                    databases and other technology assets, and business.</li>
                <li>For testing, research, analysis, and product development, including to develop and improve our 
                    Website, products, and services.</li>
                <li>To respond to law enforcement requests and as required by applicable law, court order, or governmental regulations.</li>
                <li>As described to you when collecting your personal information or as otherwise set out in the CCPA.</li>
                <li>To evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or 
                    transfer of some or all our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, 
                    in which personal information held by us about our Website users is among the assets transferred.</li>
            </ul>
            <p>
                We will not collect additional categories of personal information or use the personal information we collected for materially different, 
                unrelated, or incompatible purposes without providing you notice.
            </p>
            <h5>Use of Personal Information</h5>
            <p>
                We may share your personal information by disclosing it to a third party for a business purpose. We only make these business purpose disclosures under written contracts that describe the purposes, require the recipient to keep the personal information confidential, and prohibit using the disclosed information for any purpose except performing the contract. In the preceding 12 months, Company has disclosed personal information for a business purpose to the categories of third parties indicated in the chart below.
                We do not sell personal information. In the preceding 12 months, Company has not sold personal information.
            </p>

            <table>
            <thead>
                <tr>
                <th>Personal Information Category</th>
                <th colSpan={2}>Category of Third-Party Recipients</th>
                </tr>
                <tr>
                <th></th>
                <th>Business Purpose Disclosures</th>
                <th>Sales</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                <td>A: Identifiers.</td>
                <td>Service Providers</td>
                <td>None</td>
                </tr>
                <tr>
                <td>B: California Customer Records personal information categories.</td>
                <td>Service Providers</td>
                <td>None</td>
                </tr>
                <tr>
                <td>C: Protected classification characteristics under California or federal law.</td>
                <td>None</td>
                <td>None</td>
                </tr>
                <tr>
                <td>D: Commercial information.</td>
                <td>None</td>
                <td>None</td>
                </tr>
                <tr>
                <td>E: Biometric information.</td>
                <td>Service Providers</td>
                <td>None</td>
                </tr>
                <tr>
                <td>F: Internet or other similar network activity.</td>
                <td>Data analytic providers and Internet cookie data recipients, like Google Analytics</td>
                <td>None</td>
                </tr>
                <tr>
                <td>G: Geolocation data.</td>
                <td>None</td>
                <td>None</td>
                </tr>
                <tr>
                <td>H: Sensory data.</td>
                <td>Service Providers</td>
                <td>None</td>
                </tr>
                <tr>
                <td>I: Professional or employment-related information.</td>
                <td>None</td>
                <td>None</td>
                </tr>
                <tr>
                <td>J: Non-public education information.</td>
                <td>None</td>
                <td>None</td>
                </tr>
                <tr>
                <td>K: Inferences drawn from other personal information.</td>
                <td>None</td>
                <td>None</td>
                </tr>
            </tbody>
            </table>

            <h5>Your Rights and Choices</h5>
            <p>The CCPA provides consumers (California residents) with specific rights 
                regarding their personal information. This section describes your CCPA rights and explains how to exercise those rights.</p>
            
            <strong><i>Right to Know and Data Portability</i></strong>

            <p>You have the right to request that we disclose certain information to you about our collection and use of your personal 
                information over the past 12 months (“right to know”). Once we receive your request and confirm your identity (see Exercising 
                Your Right to Know or Delete), we will disclose to you:</p>
            
            <ul>
                <li>The categories of personal information we collected about you.</li>
                <li>The categories of sources for the personal information we collected about you.</li>
                <li>Our business or commercial purpose for collecting or selling that personal information.</li>
                <li>The categories of third parties with whom we share that personal information.</li>
                <li>If we sold or disclosed your personal information for a business purpose, two separate lists disclosing:</li>
                <ul>
                    <li>sales, identifying the personal information categories that each category of recipient purchased; and </li>
                    <li>disclosures for a business purpose, identifying the personal information categories that each category of recipient obtained.</li>
                </ul>
                <li>The specific pieces of personal information we collected about you (also called a data portability request).</li>
            </ul>

            <strong><i>Right to Delete</i></strong>

            <p>You have the right to request that we delete any of your personal information that we collected from you and retained, subject to certain exceptions (“right to delete”). Once we receive your request and confirm your identity (see Exercising Your Rights to Know or Delete), we will review your request to see if an exception allowing us to retain the information applies.
            We may deny your deletion request if retaining the information is necessary for us or our service provider(s) to:
            </p>

            <ol>
                <li>Complete the transaction for which we collected the personal information, provide a good or service that you 
                    requested, take actions reasonably anticipated within the context of our ongoing business relationship with you, 
                    fulfill the terms of a written warranty or product recall conducted in accordance with federal law, or otherwise 
                    perform our contract with you.</li>
                <li>Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity, or prosecute 
                    those responsible for such activities.</li>
                <li>Debug products to identify and repair errors that impair existing intended functionality.</li>
                <li>Exercise free speech, ensure the right of another consumer to exercise their free speech rights, 
                    or exercise another right provided for by law.</li>
                <li>Comply with the California Electronic Communications Privacy Act (Cal. Penal Code § 1546 et. seq.).</li>
                <li>Engage in public or peer-reviewed scientific, historical, or statistical research in the public interest 
                    that adheres to all other applicable ethics and privacy laws, when the information’s deletion may likely render 
                    impossible or seriously impair the research’s achievement, if you previously provided informed consent.</li>
                <li>Enable solely internal uses that are reasonably aligned with consumer expectations based on your relationship with us.</li>
                <li>Comply with a legal obligation.</li>
                <li>Make other internal and lawful uses of that information that are compatible with the context in which you provided it.</li>
            </ol>

            <p>
                We will delete or deidentify personal information not subject to one of these exceptions from our records and will 
                direct our service providers to take similar action.
            </p>
            <strong><i>Exercising Your Rights to Know or Delete</i></strong>

            <p>
               To exercise your rights to know or delete described above, please submit a request via email:
            </p>
                <ul>
                    <li>Email us at privacy@allfans.com.</li>
                    {/* <li>Visiting [WEBSITE ADDRESS TO ONLINE FORM TO SUBMIT REQUESTS].</li> IMPLEMENT LATER */}
                </ul>
            <p>Only you, or someone legally authorized to act for you, may make a request to know or delete related to your personal information. To designate an authorized agent, you must send an email to privacy@allfans.com and provide (1) a valid power of attorney, (2) the requester’s valid government-issued picture identification card, and (3) the authorized agent’s valid government-issued picture identification card.
            You may only submit a request to know twice within a 12-month period. Your request to know or delete must:
            </p>
                <ul>
                    <li>Provide sufficient information that allows us to reasonably verify you are the person about whom we collected 
                        personal information or an authorized representative, which may include:</li>
                        <ul>
                            <li>A valid government-issued picture identification card (not expired).</li>
                            <li>Email address.</li>
                            <li>Last four digits of social security number.</li>
                        </ul>
                    <li>Describe your request with sufficient detail that allows us to properly understand, evaluate, and respond to it.</li>    
                </ul>

            <p>We cannot respond to your request or provide you with personal information if we cannot verify your identity or authority to make the request and confirm the personal information relates to you.
            You do not need to create an account with us to submit a request to know or delete. However, we do consider requests made through your password protected account sufficiently verified when the request relates to personal information associated with that specific account.
            We will only use personal information provided in the request to verify the requestor’s identity or authority to make it.
            </p>
            <strong><i>Response Timing and Format</i></strong>
            <p>
            We will confirm receipt of your request within 10-business days. If you do not receive confirmation within the 10-day timeframe, please contact us.
            We endeavor to substantively respond to a verifiable consumer request within 45 days of its receipt. If we require more time (up to another 45 days), we will inform you of the reason and extension period in writing.
            If you have an account with us, we will deliver our written response to that account. If you do not have an account with us, we will deliver our written response by mail or electronically, at your option.
            Any disclosures we provide will only cover the 12-month period preceding our receipt of your request. The response we provide will also explain the reasons we cannot comply with a request, if applicable. For data portability requests, we will select a format to provide your personal information that is readily useable and should allow you to transmit the information from one entity to another entity without hindrance.
            We do not charge a fee to process or respond to your verifiable consumer request unless it is excessive, repetitive, or manifestly unfounded. If we determine that the request warrants a fee, we will tell you why we made that decision and provide you with a cost estimate before completing your request.
            </p>
            <strong>Non-Discrimination</strong>
            <p>We will not discriminate against you for exercising any of your CCPA rights. Unless permitted by the CCPA, we will not:</p>
                <ul>
                    <li>Deny you goods or services.</li>
                    <li>Charge you different prices or rates for goods or services, including through granting discounts or other benefits, or imposing penalties.</li>
                    <li>Provide you a different level or quality of goods or services.</li>
                    <li>Suggest that you may receive a different price or rate for goods or services or a different level or quality of goods or services.</li>
                </ul>
            <p>However, we may offer you certain financial incentives permitted by the CCPA that can result in different prices, rates, or 
                quality levels. Any CCPA-permitted financial incentive we offer will reasonably relate to your personal information’s value 
                and contain written terms that describe the program’s material aspects. Participation in a financial incentive program 
                requires your prior opt-in consent, which you may revoke at any time.</p>

            <strong>Other California Privacy Rights</strong>

            <p>California’s “Shine the Light” law (Civil Code § 1798.83) allows users of our Website that are California residents to request certain 
                information regarding our disclosure of personal information to third parties for their direct marketing purposes. To make that 
                request, please send an email to privacy@allfans.com.</p>

            <strong>Changes to Our Privacy Policy</strong>

            <p>We reserve the right to amend this privacy policy at our discretion and at any time. When we make changes to this privacy policy, we will 
                post the updated notice on the Website and update the notice’s effective date. Your continued use of our Website after the 
                posting of changes constitutes your acceptance of those changes.</p>

            <strong>Contact Information</strong>
            <p>If you have any questions or comments about this notice, the ways in which Innodev Solutions Inc. collects and uses 
                your information described here and in the <Link to="/privacypolicy" className='terms-link'>Privacy Policy</Link>, your choices and rights regarding that use, or wish to 
                exercise your rights under California law, please do not hesitate to contact us at:</p>
            <p><strong>Website:</strong> <a href='/contact'>https://www.allfans.com/contact</a></p>
            <p><strong>Email:</strong> privacy@allfans.com</p>

            <p>If you need to access this Policy in an alternative format due to having a disability, please contact support@allfans.com.</p>
            <div style={{ paddingTop: '220px' }}></div>
          </div>
          </div>
          </div>
          
{/*       <button className="btn btn-primary btn-primary--feedback">
        <span>Feedback</span>
      </button>
      <ul className="pf-socials">
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.9999 3.06836C6.6983 3.06836 2.3999 7.36676 2.3999 12.6684C2.3999 17.4812 5.9455 21.4556 10.5647 22.15V15.2124H8.1895V12.6892H10.5647V11.01C10.5647 8.22996 11.9191 7.00996 14.2295 7.00996C15.3359 7.00996 15.9215 7.09236 16.1983 7.12916V9.33156H14.6223C13.6415 9.33156 13.2991 10.262 13.2991 11.31V12.6892H16.1735L15.7839 15.2124H13.2991V22.17C17.9847 21.5348 21.5999 17.5284 21.5999 12.6684C21.5999 7.36676 17.3015 3.06836 11.9999 3.06836Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.99834 3.06836C4.91114 3.06836 2.3999 5.58192 2.3999 8.66992V16.6699C2.3999 19.7571 4.91347 22.2684 8.00147 22.2684H16.0015C19.0887 22.2684 21.5999 19.7548 21.5999 16.6668V8.6668C21.5999 5.5796 19.0863 3.06836 15.9983 3.06836H7.99834ZM17.5999 6.26836C18.0415 6.26836 18.3999 6.62676 18.3999 7.06836C18.3999 7.50996 18.0415 7.86836 17.5999 7.86836C17.1583 7.86836 16.7999 7.50996 16.7999 7.06836C16.7999 6.62676 17.1583 6.26836 17.5999 6.26836ZM11.9999 7.86836C14.6471 7.86836 16.7999 10.0212 16.7999 12.6684C16.7999 15.3156 14.6471 17.4684 11.9999 17.4684C9.3527 17.4684 7.1999 15.3156 7.1999 12.6684C7.1999 10.0212 9.3527 7.86836 11.9999 7.86836ZM11.9999 9.46836C11.1512 9.46836 10.3373 9.8055 9.73716 10.4056C9.13705 11.0057 8.7999 11.8197 8.7999 12.6684C8.7999 13.5171 9.13705 14.331 9.73716 14.9311C10.3373 15.5312 11.1512 15.8684 11.9999 15.8684C12.8486 15.8684 13.6625 15.5312 14.2626 14.9311C14.8628 14.331 15.1999 13.5171 15.1999 12.6684C15.1999 11.8197 14.8628 11.0057 14.2626 10.4056C13.6625 9.8055 12.8486 9.46836 11.9999 9.46836Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.4042 3.66797C3.7572 3.66797 3.37795 4.39673 3.74795 4.92773L9.73623 13.4863L3.72451 20.5137C3.33551 20.9677 3.65776 21.668 4.25576 21.668H4.91982C5.21282 21.668 5.49154 21.5394 5.68154 21.3164L10.9198 15.1797L14.8632 20.8145C15.2382 21.3485 15.8499 21.668 16.5019 21.668H19.8358C20.4828 21.668 20.8621 20.9402 20.4921 20.4102L14.1737 11.3672L19.9003 4.6582C20.2323 4.2682 19.9553 3.66797 19.4433 3.66797H18.5976C18.3056 3.66797 18.0278 3.79558 17.8378 4.01758L12.996 9.67773L9.39443 4.52344C9.02043 3.98744 8.40976 3.66797 7.75576 3.66797H4.4042Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.0001 3.86719C8.6513 3.86719 4.30479 4.70625 4.30479 4.70625L4.29385 4.71875C2.76863 4.96268 1.6001 6.27329 1.6001 7.86719V12.6672V12.6687V17.4672V17.4688C1.60159 18.23 1.87439 18.9657 2.36954 19.5439C2.86468 20.1221 3.54972 20.5049 4.30166 20.6234L4.30479 20.6281C4.30479 20.6281 8.6513 21.4688 12.0001 21.4688C15.3489 21.4688 19.6954 20.6281 19.6954 20.6281L19.697 20.6266C20.4497 20.5082 21.1356 20.1252 21.6311 19.5463C22.1266 18.9674 22.3993 18.2307 22.4001 17.4688V17.4672V12.6687V12.6672V7.86719C22.399 7.10569 22.1263 6.36955 21.6312 5.79103C21.136 5.21252 20.4507 4.82955 19.6985 4.71094L19.6954 4.70625C19.6954 4.70625 15.3489 3.86719 12.0001 3.86719ZM9.6001 8.98594L16.0001 12.6672L9.6001 16.3484V8.98594Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
      </ul> */}
    </div>
        </>
  );
};

export default CCPAPolicy;
